import { useAtom } from 'jotai'
import { useRouter } from 'next/router'
import { TagsFilters as View } from 'ui-components'
import { getTagsQuery } from 'utils'
import { atoms } from '~map-tags/queries/useSearchTags'

export function TagsFilters() {
  const router = useRouter()

  const [query, setQuery] = useAtom(atoms.query)
  const [sort, setSort] = useAtom(atoms.sort)

  const handleInputChange = (event) => {
    const value = event.target.value
    setQuery(value)
  }

  const handleChange = (event) => {
    const value = event.target.value
    setSort(value)
    router.push(getTagsQuery({ query, sort: value }))
  }

  const handleApply = () => {
    router.push(getTagsQuery({ query, sort }))
  }

  return (
    <View
      inputValue={query}
      optionValue={sort}
      onInputChange={handleInputChange}
      onApply={handleApply}
      onChange={handleChange}
    />
  )
}
